export default "__VITE_ASSET__CRn5Z8As__"